import { createDialog, type CreateDialogInput } from '@edge/spark/feature-dialog'
import {
    SetVehicleInfoApiDocument,
    SetVehicleInfoApiQuery,
    MutationResolvers,
    SetVehicleInfoResults,
} from '../../../../../generated/graphql'

const LOADING_MESSAGE = 'Updating Vehicle Info...'
const SUCCESS_MESSAGE = 'Vehicle Updated'
const ERROR_HEADING_MESSAGE = 'Something went wrong.'
const ERROR_MESSAGE = 'Your changes could not be saved, please try again.'

const setVehicleInfo: MutationResolvers['setVehicleInfo'] = async (
    _root,
    {
        amsType,
        assetId,
        floor,
        announcements,
        expectedAnnouncements,
        selectedLightId,
        stockNumber,
        cancelProxyBids,
        numberOfProxyBids,
    },
    { client },
): Promise<SetVehicleInfoResults | null> => {
    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    createDialog({
        message: LOADING_MESSAGE,
        timeout: 30000, // default AWS timeout
        action: 'SPINNER',
    })

    let variables: any = {
        amsType,
        assetId,
        newFloor: floor,
        oldFloor: -1,
        announcements,
        expectedAnnouncements,
        stockNumber,
        cancelProxyBids,
        numberOfProxyBids,
    }

    if (selectedLightId !== undefined) {
        variables = {
            ...variables,
            newLight: selectedLightId?.toString(),
            oldLight: '-1',
        }
    }

    const { data } = await client.query<SetVehicleInfoApiQuery>({
        query: SetVehicleInfoApiDocument,
        variables,
        fetchPolicy: 'network-only',
    })

    const result = data?.auction?.setVehicleInfo?.results?.[0]
    const cancelProxyBidResult = data?.auction?.setVehicleInfo?.cancelProxyBidsResult

    let dialogInput: CreateDialogInput = {
        message: SUCCESS_MESSAGE,
        timeout: 5000,
        color: 'success',
    }

    const errorDialogInput: CreateDialogInput = {
        heading: ERROR_HEADING_MESSAGE,
        message: ERROR_MESSAGE,
        type: 'ALERT',
    }

    if (!result?.success) {
        let messageString = result?.message && result?.message !== '' ? result?.message : ERROR_MESSAGE

        if (cancelProxyBidResult?.success === false) {
            messageString += ` Proxy bids were NOT successfully removed. ${
                cancelProxyBidResult?.errors?.join(', ') || ''
            }`
        }

        dialogInput = {
            ...errorDialogInput,
            message: messageString,
        }
    }

    if (result?.success && cancelProxyBidResult?.success === false) {
        const messageString = `Proxy bids were NOT successfully removed. ${
            cancelProxyBidResult?.errors?.join(', ') || ''
        }`

        dialogInput = {
            ...errorDialogInput,
            message: messageString,
        }
    }

    createDialog(dialogInput)

    const response = data?.auction?.setVehicleInfo || null
    return response
}

export default setVehicleInfo
